module.exports = __webpack_public_path__ + "mo/img/08_Creative-Development.46c96933.png";